import { Box, Link } from "@mui/material";
import logo from "../../assets/logos/white_msuite_landscape.png";

const HeaderLogo = () => {
  return (
    <Box
      position="absolute"
      top={31}
      left={43}
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
    >
      <Link
        href="https://msuite.com"
        target="_blank"
        rel="noopener noreferrer"
        display="inline-block"
      >
        <img src={logo} alt="MSUITE Logo" height={91} width={167} />
      </Link>
    </Box>
  );
};

export default HeaderLogo;
